<h4 mat-dialog-title data-testid="address-edit-title">Редактирование адреса</h4>
<app-close-button [formGroup]="addressForm" [dialogRef]="dialogRef"/>
<mat-dialog-content>
    <form class="flex-column" [formGroup]="addressForm" (ngSubmit)="onSubmit()">

        <mat-form-field appearance="fill">
            <mat-label>Адрес</mat-label>
            <textarea matInput formControlName="address" data-testid="address-edit-textarea"></textarea>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Широта</mat-label>
            <input matInput type="number" formControlName="latitude" data-testid="latitude-edit-input"/>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Долгота</mat-label>
            <input matInput type="number" formControlName="longitude" data-testid="longitude-edit-input"/>
        </mat-form-field>

        <button mat-flat-button color="primary" type="submit" [disabled]="!addressForm.valid" data-testid="save-address-button">Сохранить</button>
    </form>
</mat-dialog-content>

